module.exports = __webpack_public_path__ + "81ba0e6b.png";